<template>
  <modal 
    name="add-liability-modal" 
    :pivotY="0.2"
    height="auto"
    :width="'680px'"
    :adaptive="true"
    :scrollable="true"
    @before-open="beforeOpen">
    
    <div class="modal-header">
      <div class="modal-title">
        What type of liability would you like to add?
      </div>

      <a href="#"
        @click.prevent="$modal.hide('add-liability-modal')"
        class="text-gray-500 hover:text-gray-700">
        <svg width="20" height="20" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#x-circle"/>
        </svg>
      </a>
    </div>

    <div class="modal-body">
      <div class="flex flex-wrap -mx-2">
				<div class="w-1/4 p-2">
          <button class="item-button" v-on:click="addLiabilityLocal(0)">
            <img src="https://img.icons8.com/color/96/000000/cottage.png" class="inline w-12" />
            <div class="mt-2">Property Loan</div>
          </button>
        </div>

        <div class="w-1/4 p-2">
          <button class="item-button" v-on:click="addLiabilityLocal(1)">
            <img src="https://img.icons8.com/color/96/000000/mastercard-credit-card.png" class="inline w-12" />
            <div class="mt-2">Credit Card</div>
          </button>
        </div>

        <div class="w-1/4 p-2">
          <button class="item-button" v-on:click="addLiabilityLocal(2)">
            <img src="https://img.icons8.com/color/96/000000/car-rental.png" class="inline w-12" />
            <div class="mt-2">Car Lease</div>
          </button>
        </div>

        <div class="w-1/4 p-2">
          <button class="item-button" v-on:click="addLiabilityLocal(3)">
            <img src="https://img.icons8.com/color/96/000000/bank-building.png" class="inline w-12" />
            <div class="mt-2">Personal Loan</div>
          </button>
        </div>

        <div class="w-1/4 p-2">
          <button class="item-button" v-on:click="addLiabilityLocal(5)">
            <img src="https://img.icons8.com/color/96/000000/curriculum.png" class="inline w-12" />
            <div class="mt-2">HECS/HELP Debt</div>
          </button>
        </div>

        <div class="w-1/4 p-2">
          <button class="item-button" v-on:click="addLiabilityLocal(6)">
            <img src="https://img.icons8.com/color/96/000000/cash-register.png" class="inline w-12" />
            <div class="mt-2">Buy-Now-Pay-Later</div>
          </button>
        </div>

        <div class="w-1/4 p-2">
          <button class="item-button" v-on:click="addLiabilityLocal(4)">
            <img src="https://img.icons8.com/color/96/000000/restrict.png" class="inline w-12" />
            <div class="mt-2">Other</div>
          </button>
        </div>

      </div>

      <div class="mt-4 pt-4 border-t flex items-center" v-if="templates != null && templates.length > 0">
        <div class="text-base">
          Add liabilities via template
        </div>

        <select v-on:change="templateSelectedLocal" class="ml-4 border border-gray-500">
          <option>Select a template</option>
          <template v-for="(template, index) in templates">
            <option :value="template.id">{{ template.name }}</option>
          </template>
        </select>
      </div>
    </div>
  </modal>
</template>

<script>
  export default {

    props : {
      templates : {
        type     : Array,
        required : false
      },

      templateSelected : {
        type     : Function,
        required : false
      }
    },
    
    data() {
      return {
        addLiability : null
      }
    },

    methods : {
      beforeOpen(event) {
        this.addLiability = event.params.addLiability
      },

      addLiabilityLocal(type) {
        this.addLiability(type)
        this.$modal.hide('add-liability-modal')
      },

      templateSelectedLocal(e) {
        this.templateSelected(e.target.value)
        this.$modal.hide('add-liability-modal')
      }
    }
  }
</script>